import { concat, get, isArray } from 'lodash';
import React from 'react';
import { FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS } from 'src/lib/constants/componentsPath';
import { ANTRAG_TYP, ART_DES_ANTRAGS } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { checkIfAnlagenHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import AnlagenPruefAssistenzGlobal, { getFormStrucAnlagenPruefAssistenzGlobal } from './content/AnlagenPruefAssistenzGlobal';
import OptionaleAnlagenGlobal from './content/OptionaleAnlagenGlobal';
import PflichtAnlagenGlobal, { getFormStrucPflichtAnlagenGlobal } from './content/PflichtAnlagenGlobal';
import SonstigeAnlagenGlobal, { getFormStrucSonstigeAnlagenGlobal } from './content/SonstigeAnlagenGlobal';

// import Schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureAnlagenGlobal = (application: any, readOnly: boolean) => {
	// const hasValidAnlagen = (anlagen: any[]): boolean => isArray(anlagen) && anlagen.length > 0;

	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const foerderprogramm = get(application, P.Foerderprogramm.path, {});
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;

	const paths =
		antragsTyp === ANTRAG_TYP.Skizze ? FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Skizze
		: isFormantrag ? FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Formantrag
		: FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Antrag;

	const hasValidAnlagen = (anlagen: any[]) => {
		if (isArray(anlagen) && anlagen.length > 0) {
			return anlagen.some((ele) => get(ele, 'Bezeichnung_Des_Dokuments', '').trim() !== '');
		} else {
			return false;
		}
	};

	let treeNodes: TreeNodeType[] = [];

	const pflichtAnlagen = get(application, P.Anlagen_Erforderliche_Anlagen.path, []);
	const optionaleAnlagen = get(application, P.Anlagen_Optionale_Anlagen.path, []);
	const hasCommentAnlagen = checkIfAnlagenHasComment(readOnly, application);

	if (hasValidAnlagen(pflichtAnlagen) || hasValidAnlagen(optionaleAnlagen)) {
		treeNodes = [
			{
				label: 'Anlagen',
				content: <AnlagenPruefAssistenzGlobal />,
				hasComment: hasCommentAnlagen,
				formStruc: getFormStrucAnlagenPruefAssistenzGlobal(application),
				children: [
					...(hasValidAnlagen(pflichtAnlagen) ?
						[
							{
								label: get(foerderprogramm, paths.PflichtAnlageTitel, 'Pflichtanlagen'),
								content: <PflichtAnlagenGlobal hasComment={hasCommentAnlagen} />,
								formStruc: getFormStrucPflichtAnlagenGlobal(application),
							},
						]
					:	[]),
					...(hasValidAnlagen(optionaleAnlagen) ?
						[
							{
								label: get(foerderprogramm, paths.OptionaleAnlageTitel, 'Optionale Anlagen'),
								content: <OptionaleAnlagenGlobal hasComment={hasCommentAnlagen} />,
							},
						]
					:	[]),
					{
						label: get(foerderprogramm, paths.SontigeAnlageTitel, 'Sonstige Anlagen'),
						content: <SonstigeAnlagenGlobal hasComment={hasCommentAnlagen} />,
						formStruc: getFormStrucSonstigeAnlagenGlobal(application),
					},
				],
			},
		];
	} else {
		treeNodes = [
			{
				label: 'Anlagen',
				content: <SonstigeAnlagenGlobal showPruefAssistenz={true} hasComment={hasCommentAnlagen} />,
				hasComment: hasCommentAnlagen,
				formStruc: concat(getFormStrucAnlagenPruefAssistenzGlobal(application), getFormStrucSonstigeAnlagenGlobal(application)),
			},
		];
	}

	return treeNodes;
};
